enum Routes {
    CONNECTIONS = '/connections',
    CONNECTIONS_DETAILS = '/connections/details',
  }
  
  export default Routes